import React from 'react';

export const SummaryCart = ({ total }) => {
  return (
    <div className="col-lg-4">

    <div className="card cart-summary">
        <div className="card-body">
            <h5 className="card-title mb-4">Order Summary</h5>
            <div className="d-flex justify-content-between mb-3">
                <span>Subtotal</span>
                <span>${ total }</span>
            </div>
            <div className="d-flex justify-content-between mb-3">
                <span>Shipping</span>
                <span>$0.00</span>
            </div>
            <div className="d-flex justify-content-between mb-3">
                <span>Tax</span>
                <span>$0.00</span>
            </div>
            <hr />
            <div className="d-flex justify-content-between mb-4">
                <strong>Total</strong>
                <strong>${ total }</strong>
            </div>
            <button className="btn btn-primary w-100">Proceed to Checkout</button>
        </div>
    </div>
    </div>
  )
}
